import classes from "./SubmitSucces.module.css";
export default function SubmitSuccess() {
  return (
    <>
      <div className={classes.container}>
        <div className={classes.content}>
          <p> Form submitted successfully</p>
        </div>
      </div>
    </>
  );
}
